// Commons
const PATHNAME_MAINTAIN = '/maintain';
const PATHNAME_DETAIL = '/detail';
const PATHNAME_LIST = '/list';
const PATHNAME_ADD_NEW_ASSIGNMENT = '/add-new-assignment';

const PATHNAME_PLAN_ACTIVITY = '/plan-activity';
const PATHNAME_LEADS_TRACKER = '/leads-tracker';
const PATHNAME_REPORTS = '/reports';
const PATHNAME_TEAM_MANAGEMENT = '/team-management';
const PATHNAME_AGENCY_NEWS = '/agency-news';
const PATHNAME_USER_GUIDE = '/user-guide';
const PATHNAME_AUTH = '/auth';

const pathnames = {
  home: () => '/',
  debug: () => '/debug',
  unauthorized: () => '/403',
  notFound: () => '/404',

  notification: () => '/notification',

  // SPV Dashboard
  setTarget: () => '/set-target',

  // BM Performance
  branchPerformance: () => '/branch-performance',

  // SPV Performance
  spvPerformance: () => '/spv-performance',

  // KPI & Incentive
  kpiIncentive: () => '/kpi-incentive',

  // Report
  maintainReport: () => `${PATHNAME_REPORTS}${PATHNAME_MAINTAIN}`,
  maintainReportList: (id: string) =>
    `${pathnames.maintainReport()}${PATHNAME_LIST}/${id}`,
  maintainReportDetail: (id: string) =>
    `${pathnames.maintainReport()}${PATHNAME_DETAIL}/${id}`,

  recruitReport: () => `${PATHNAME_REPORTS}/recruit`,

  // Agent Performance
  agentPerformance: () => '/agent-performance',
  historicalAgentPerformance: (areMarketingId: string) =>
    `${pathnames.agentPerformance()}/${areMarketingId}`,

  // ARE Performance
  arePerformance: () => '/are-performance',

  // Plan Activity
  maintainActivity: () => `${PATHNAME_PLAN_ACTIVITY}${PATHNAME_MAINTAIN}`,
  maintainActivityScheduleDetail: (scheduleId: string) =>
    `${pathnames.maintainActivity()}/schedule/${scheduleId}`,
  addNewMaintainAssignment: () =>
    `${pathnames.maintainActivity()}${PATHNAME_ADD_NEW_ASSIGNMENT}`,

  recruitActivity: () => `${PATHNAME_PLAN_ACTIVITY}/recruit`,
  addNewRecruitAssignment: () =>
    `${pathnames.recruitActivity()}${PATHNAME_ADD_NEW_ASSIGNMENT}`,

  maintainNonRegistActivity: () => `/plan-activity/maintain-non-regist`,
  maintainNonRegistActivityScheduleDetail: (scheduleId: string) =>
    `${pathnames.maintainNonRegistActivity()}/schedule/${scheduleId}`,
  addNewMaintainNonRegistAssignment: () =>
    `${pathnames.maintainNonRegistActivity()}${PATHNAME_ADD_NEW_ASSIGNMENT}`,

  weeklyMeeting: () => `${PATHNAME_PLAN_ACTIVITY}/weekly-meeting`,
  addNewWeeklyMeetingReport: () =>
    `${pathnames.weeklyMeeting()}/add-new-report`,

  joinVisit: () => `${PATHNAME_PLAN_ACTIVITY}/join-visit`,
  branchRoutineChecklist: () =>
    `${PATHNAME_PLAN_ACTIVITY}/branch-routine-checklist`,
  addNewJoinVisitReport: () => `${pathnames.joinVisit()}/add-new-report`,
  joinVisitReportGuideline: () => '/pdf/join-visit-report-guidline.pdf',

  oneOnOne: () => `${PATHNAME_PLAN_ACTIVITY}/1-on-1`,
  addNewOneOnOneReport: () => `${pathnames.oneOnOne()}/add-new-report`,

  // Team Management
  agentManagement: () => `${PATHNAME_TEAM_MANAGEMENT}/agent`,
  teamHierarchy: () => `${PATHNAME_TEAM_MANAGEMENT}/hierarchy`,
  superAgentManagement: () => `${PATHNAME_TEAM_MANAGEMENT}/super-agent`,
  agentManagementDetail: (baId: string) =>
    `${PATHNAME_TEAM_MANAGEMENT}/agent/${baId}`,
  agentManagementBlacklistDetail: (baId: string) =>
    `${PATHNAME_TEAM_MANAGEMENT}/blacklist/${baId}`,

  // Leads Tracker
  leadsTracker: () => PATHNAME_LEADS_TRACKER,
  leadsTrackerDetail: (
    agentId: string,
    applicationGroupId: string,
    applicationId: string,
  ) =>
    `${PATHNAME_LEADS_TRACKER}/${agentId}/${applicationGroupId}/${applicationId}`,

  // Agency News
  agencyNewsUpdates: () => `${PATHNAME_AGENCY_NEWS}/updates`,
  agencyNewsPromoMaterial: () => `${PATHNAME_AGENCY_NEWS}/promo-material`,
  agencyNewsLoyaltyProgram: () => `${PATHNAME_AGENCY_NEWS}/loyalty-program`,
  agencyNewsTrainingMaterial: () => `${PATHNAME_AGENCY_NEWS}/training-material`,

  // User Guide
  userGuide: () => PATHNAME_USER_GUIDE,

  // auth
  login: () => PATHNAME_AUTH,

  // Confins Migration
  settingAgentExpiry: () => '/setting-agent-expiry',
  mediaManagement: () => '/media-management',
  mediaManagementGenfi: () => '/media-management-genfi',
};

export default pathnames;
